import { useLocation, Link } from 'react-router-dom';

// Manually define breadcrumbs for known paths
const breadcrumbMap = {
  '/': 'Home',
  '/shop': 'Shop',
  '/shop/product/': 'Product',
  '/about': 'About',
  '/contact': 'Contact',
  '/blog': 'Blog',
  '/blog/blog-detail/': 'Blog Detail',
  '/glossary': 'Glossary',
  '/social-responsibility': 'Social Responsibility',
};



function Breadcrumbs() {
    const location = useLocation();
    const pathnames = location.pathname.split('/').filter((x) => x);
  
    const generatePath = (index) =>
      '/' + pathnames.slice(0, index + 1).join('/');
  
    const matchedPaths = [];
  
    return (
        <div className="bread-crumb flex-w p-l-25 p-r-15 p-t-30 p-lr-0-lg">
          <Link to="/" className="stext-109 cl8 hov-cl1 trans-04">
            Home
            <i className="fa fa-angle-right m-l-9 m-r-10" aria-hidden="true"></i>
          </Link>
  
          {pathnames.map((_, index) => {
            const to = '/' + pathnames.slice(0, index + 1).join('/');

            const matchedKey = Object.keys(breadcrumbMap).reverse().find((key) =>
              to.startsWith(key)
            );

            if (!matchedKey || matchedPaths.includes(matchedKey)) return null;
            matchedPaths.push(matchedKey);

            const label = breadcrumbMap[matchedKey] || decodeURIComponent(pathnames[index]);
            const isLast = index === pathnames.length - 1;

            return isLast ? (
              <span key={to} className="stext-109 cl4">
                {label}
              </span>
            ) : (
              <span key={to}>
                <Link to={to} className="stext-109 cl8 hov-cl1 trans-04">
                  {label}
                </Link>
                <i className="fa fa-angle-right m-l-9 m-r-10" aria-hidden="true"></i>
              </span>
            );
          })}
        </div>
    );
  }
  
  export default Breadcrumbs;